import { proxy } from "valtio";
import { proxyMap } from "valtio/utils";

const navbarProxy = proxy({
  navbarProxyMap: proxyMap<string, string[]>([
    ["/", ["General", "Home"]],
    ["/organization", ["General", "Organization"]],
    ["/plans", ["General", "Plans"]],
    ["/subscriptions", ["General", "Subscriptions"]],
    ["/users", ["Administation", "Users"]]
  ])
});

export const getNavbarProxy = () => navbarProxy;
